import styled from 'styled-components'
import { AllColors } from '../../types/Colors'

const Alert = styled.div<{ color?: AllColors }>`
  width: 100%;
  background-color: ${({ color }) => `var(--${color}-100)`};
  border-radius: 8px;
  padding: 16px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ color }) => `var(--${color}-500)`};
  margin-top: 16px;
`
Alert.defaultProps = {
  color: 'blue',
}
export default Alert
